<script lang="ts">
	import { format } from 'svelte-i18n';
	import { copy } from 'src/helpers/copy_text';
	import { SidepanelContent, Container, Text, IconButton, Button } from '@Shelly/shelly-design-system';
	import AlarmDeleteModal from 'src/components/Lists/Alarms/AlarmDeleteModal.svelte';
	import { canManageHomeEntities } from 'src/helpers/houses/homes_helpers';
	import { homes } from 'src/stores/account/home';
	import { isActiveHomeShared } from 'src/helpers/houses/homes_helpers';
	import SharedHomeOwnerManagedAlert from 'src/components/SharedHome/SharedHomeOwnerManagedAlert.svelte';

	export let id;
	export let alarm;

	let showDeleteAlarmModal = false;

	$: isSharedHomeActive = isActiveHomeShared($homes.list);
</script>

<SidepanelContent>
	<Container backgroundColor="color-0" padding="xs">
		<Text styleType="label-large" class="text-center mb-s-plus">
			{$format('alarm_zone_id', { default: 'Alarm zone id' })}
		</Text>
		<div class="d-flex justify-content-center align-items-center">
			<Text class="text-break-all text-center" styleType="body">{id}</Text>

			<IconButton
				aria-label={$format('button_copy_alarm_id', {
					default: 'Copy alarm ID',
				})}
				class="ml-s"
				icon="fas fa-copy"
				on:click={() =>
					copy(
						id,
						$format('copied_successfully', {
							default: 'Copied successfully!',
						}),
					)}
			/>
		</div>
	</Container>

	{#if isSharedHomeActive}
		<SharedHomeOwnerManagedAlert class="mt-s" context="delete_entity" />
	{/if}
	<Button
		class="mt-s"
		width="full"
		size="m"
		variant="danger"
		icon="fas fa-trash"
		disabled={isSharedHomeActive}
		aria-label={$format('button_delete_alarm', {
			default: 'Delete alarm',
		})}
		on:click={() => (showDeleteAlarmModal = true)}
	>
		{$format('button_delete_alarm', {
			default: 'Delete alarm',
		})}
	</Button>
</SidepanelContent>

<AlarmDeleteModal bind:showDeleteAlarmModal alarm_id={id} alarm_name={alarm._meta.name} />
